import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query';

import { Contractor } from '../../domain/contractor';
import { ContractorsFilters } from '../../domain/contractorsFilters';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

export const useContractorsRepository = (filters?: ContractorsFilters) => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();
    const hasFilters = filters && Object.keys(filters).length > 0;

    const query = useQuery({
        queryKey: hasFilters ? ['contractors', filters]: ['contractors'],
        placeholderData: keepPreviousData,
        queryFn: async () => {
            const token = await getJwtToken();

            let query = '';

            if (filters && filters.query) {
                query = `?q=${filters.query.value}`;
            }

            const response = await fetch(`${BACKEND_URL}/contractors${query}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const body = await response.json() as Contractor[];

            return body.sort((a, b) => {
                if (a.blacklist && !b.blacklist) {
                    return 1;
                }
                if (!a.blacklist && b.blacklist) {
                    return -1;
                }

                return 0;
            });
        },
    });

    const refetch = () => {
        queryClient.invalidateQueries({
            queryKey: ['contractors']
        });
    };

    return {
        ...query,
        refetch
    };
};